// src/pages/help/topics/challenges.js
// Guide « Challenges ». Contenu validé — toute modification se fait ici.
export const fr = {
  title: "Challenges",
  tagline: "Fixer un objectif et suivre sa progression",
  readMin: 6,
  intro:
    "La partie Challenges permet à l'utilisateur de se fixer un objectif global à atteindre sur une période déterminée. À partir du capital du compte, de l'objectif choisi et de la durée du challenge, FullMetrix calcule automatiquement les petits objectifs intermédiaires nécessaires pour atteindre l'objectif final.",
  brief: [
    "Définir un objectif global et une durée, les paliers sont calculés",
    "Suivre automatiquement sa progression grâce à l'Agent IA",
    "Voir si l'on est en avance ou en retard sur le rythme prévu",
  ],
  steps: [
    {
      title: "Connecter le compte MT5",
      text: "Agent IA installé, token valide, trading algorithmique activé, WebRequest autorisé, MT5 ouvert et connecté.",
    },
    {
      title: "Créer le challenge",
      text: "Définis le compte concerné, le capital de départ, l'objectif final et la durée.",
    },
    {
      title: "Laisser FullMetrix calculer",
      text: "Bénéfice total à atteindre, bénéfice moyen par jour, montant restant, progression et rythme nécessaire.",
    },
    {
      title: "Suivre la progression",
      text: "Les résultats sont synchronisés automatiquement : aucune saisie manuelle nécessaire.",
    },
  ],
  tips: [
    "Un objectif est un repère, pas une obligation de trader : ne prends jamais une position uniquement pour rattraper un objectif journalier.",
    "Être en avance est une occasion de réduire l'exposition et de sécuriser, pas de chercher plus de trades.",
    "Être en retard n'impose ni d'augmenter le lot, ni d'abandonner sa gestion du risque : on peut revoir l'objectif ou prolonger la durée.",
  ],
  faq: [
    {
      q: "Qu'est-ce que la partie Challenges ?",
      a:
        "La partie Challenges permet à l'utilisateur de se fixer un objectif global à atteindre sur une période déterminée.\n\n" +
        "À partir du capital du compte, de l'objectif choisi et de la durée du challenge, FullMetrix calcule automatiquement les petits objectifs intermédiaires nécessaires pour atteindre l'objectif final.",
    },
    {
      q: "Que faut-il faire pour utiliser un challenge ?",
      a:
        "Pour fonctionner correctement, la partie Challenges doit être reliée à un compte MetaTrader 5 grâce à l'Agent IA.\n\n" +
        "Il faut donc :\n" +
        "• installer l'Agent IA sur le compte MT5\n" +
        "• connecter le compte avec un token valide\n" +
        "• activer le trading algorithmique\n" +
        "• autoriser le WebRequest de FullMetrix\n" +
        "• laisser MetaTrader 5 ouvert et connecté à Internet\n\n" +
        "Une fois le compte connecté, les résultats sont synchronisés automatiquement.",
    },
    {
      q: "Comment créer un challenge ?",
      a:
        "L'utilisateur doit définir :\n" +
        "• le compte concerné\n" +
        "• le capital de départ\n" +
        "• l'objectif final à atteindre\n" +
        "• la durée du challenge\n\n" +
        "Exemple :\n" +
        "Un compte possède un capital de 50 000 $ et l'utilisateur souhaite réaliser 30 % sur les 7 prochains jours.\n\n" +
        "FullMetrix calcule alors automatiquement :\n" +
        "• le bénéfice total à atteindre\n" +
        "• le bénéfice moyen à réaliser chaque jour\n" +
        "• le montant restant\n" +
        "• la progression du challenge\n" +
        "• le rythme nécessaire pour atteindre l'objectif final",
    },
    {
      q: "À quoi servent les objectifs journaliers ?",
      a:
        "Les objectifs journaliers servent principalement de repères.\n\n" +
        "Ils ne sont pas conçus pour obliger le trader à générer un bénéfice précis chaque jour.\n\n" +
        "Ils permettent plutôt de comprendre qu'un grand objectif peut être atteint grâce à une succession de petits résultats.\n\n" +
        "Par exemple, un trader peut réaliser une bonne performance dès le premier jour, mais continuer à chercher davantage sans réelle nécessité.\n\n" +
        "Le challenge lui permet alors de voir qu'il a déjà pris de l'avance et qu'il n'a pas besoin de forcer de nouvelles positions.",
    },
    {
      q: "Le challenge met-il une pression sur le trader ?",
      a:
        "Non.\n\n" +
        "La partie Challenges n'a pas été conçue pour pousser l'utilisateur à trader davantage ou à prendre plus de risques.\n\n" +
        "Son objectif est de lui donner une vision claire de sa progression.\n\n" +
        "L'utilisateur ne doit jamais prendre une position uniquement pour rattraper un objectif journalier.\n\n" +
        "Un objectif est un repère, pas une obligation de trader.",
    },
    {
      q: "Comment la progression est-elle calculée ?",
      a:
        "Grâce aux données transmises automatiquement par l'Agent IA, FullMetrix peut suivre :\n" +
        "• le capital actuel\n" +
        "• le profit déjà réalisé\n" +
        "• le montant restant à atteindre\n" +
        "• le pourcentage de progression\n" +
        "• les objectifs déjà atteints\n" +
        "• le rythme moyen du challenge\n\n" +
        "L'utilisateur n'a normalement pas besoin de saisir manuellement ses résultats.",
    },
    {
      q: "Que signifie être en avance ou en retard ?",
      a:
        "L'utilisateur est considéré comme en avance lorsque ses résultats sont supérieurs au niveau normalement attendu à ce moment du challenge.\n\n" +
        "Il est considéré comme en retard lorsque sa progression est inférieure au repère calculé.\n\n" +
        "Ces indications servent uniquement à aider l'utilisateur à mieux comprendre sa situation.\n\n" +
        "Elles ne signifient pas qu'il doit absolument trader pour rattraper son retard.",
    },
    {
      q: "Que se passe-t-il si je réalise beaucoup de profit dès le début ?",
      a:
        "Si l'utilisateur dépasse rapidement son objectif intermédiaire, FullMetrix peut indiquer qu'il est en avance.\n\n" +
        "Cela peut lui permettre de :\n" +
        "• réduire son exposition\n" +
        "• éviter de surtrader\n" +
        "• sécuriser sa progression\n" +
        "• rester fidèle à son plan\n" +
        "• attendre de meilleures opportunités\n\n" +
        "Le fait d'être en avance ne signifie pas qu'il faut continuer à chercher plus de trades.",
    },
    {
      q: "Que se passe-t-il si je suis en retard ?",
      a:
        "Si l'utilisateur est en retard, FullMetrix l'indique afin qu'il puisse comprendre que son rythme actuel est inférieur au repère prévu.\n\n" +
        "Cela ne signifie pas qu'il doit :\n" +
        "• augmenter son lot\n" +
        "• prendre davantage de positions\n" +
        "• abandonner sa gestion du risque\n" +
        "• forcer des opportunités\n\n" +
        "Il peut plutôt :\n" +
        "• revoir son objectif\n" +
        "• prolonger la durée\n" +
        "• analyser ses résultats\n" +
        "• rester patient\n" +
        "• continuer à respecter sa stratégie",
    },
    {
      q: "Peut-on suivre plusieurs challenges ?",
      a:
        "Selon les options disponibles sur FullMetrix, l'utilisateur peut retrouver :\n" +
        "• les challenges actifs\n" +
        "• les challenges réussis\n" +
        "• les challenges en retard\n" +
        "• la progression moyenne\n" +
        "• le profit total généré\n" +
        "• l'historique des synchronisations\n\n" +
        "Cela permet de comparer plusieurs objectifs et de suivre son évolution dans le temps.",
    },
    {
      q: "Le challenge garantit-il l'atteinte de l'objectif ?",
      a:
        "Non.\n\n" +
        "FullMetrix calcule un plan de progression et fournit des repères.\n\n" +
        "Il ne garantit pas que l'objectif sera atteint.\n\n" +
        "Le résultat dépend notamment :\n" +
        "• de la stratégie de l'utilisateur\n" +
        "• des conditions du marché\n" +
        "• de sa gestion du risque\n" +
        "• de sa discipline\n" +
        "• de la qualité de ses décisions\n" +
        "• des performances réellement obtenues",
    },
    {
      q: "Que faire si les résultats ne se synchronisent pas ?",
      a:
        "Vérifie :\n" +
        "• que MetaTrader 5 est ouvert\n" +
        "• que l'Agent IA est actif\n" +
        "• que le token est valide\n" +
        "• que le trading algorithmique est activé\n" +
        "• que le WebRequest de FullMetrix est toujours autorisé\n" +
        "• que le bon compte est connecté\n" +
        "• que la connexion Internet fonctionne\n\n" +
        "Actualise ensuite la page Challenges.",
    },
    {
      q: "Comment contacter le support ?",
      a:
        "Pour obtenir une réponse plus rapide, nous recommandons de contacter le support FullMargin par WhatsApp.\n\n" +
        "Il est conseillé d'envoyer :\n" +
        "• l'adresse e-mail du compte FullMargin\n" +
        "• le compte MT5 concerné\n" +
        "• le nom du token utilisé\n" +
        "• l'objectif et la durée du challenge\n" +
        "• une capture de la page Challenges\n" +
        "• une description précise du problème",
    },
  ],
  related: ["agent-ia-mt5", "journal-auto", "strategy-hub"],
};

export const en = {
  title: "Challenges",
  tagline: "Set a target and follow your progress",
  readMin: 6,
  intro:
    "The Challenges section lets you set an overall target to reach over a given period. From the account balance, the chosen target and the challenge duration, FullMetrix automatically computes the intermediate milestones needed to reach the final goal.",
  brief: [
    "Set an overall target and a duration — milestones are computed for you",
    "Track progress automatically through the AI Agent",
    "See whether you are ahead of or behind the expected pace",
  ],
  steps: [
    {
      title: "Connect the MT5 account",
      text: "AI Agent installed, valid token, algorithmic trading enabled, WebRequest allowed, MT5 open and connected.",
    },
    { title: "Create the challenge", text: "Define the account, the starting balance, the final target and the duration." },
    {
      title: "Let FullMetrix compute",
      text: "Total profit to reach, average daily profit, remaining amount, progress and the pace required.",
    },
    { title: "Follow the progress", text: "Results are synced automatically: no manual entry needed." },
  ],
  tips: [
    "A target is a reference point, not an obligation to trade: never open a position just to catch up on a daily target.",
    "Being ahead is a chance to reduce exposure and secure progress, not to look for more trades.",
    "Being behind never requires increasing lot size or dropping risk management: you can revise the target or extend the duration.",
  ],
  faq: [
    {
      q: "What is the Challenges section?",
      a:
        "The Challenges section lets you set an overall target to reach over a given period.\n\n" +
        "From the account balance, the chosen target and the challenge duration, FullMetrix automatically computes the intermediate milestones needed to reach the final goal.",
    },
    {
      q: "What do I need to use a challenge?",
      a:
        "To work properly, the Challenges section must be linked to a MetaTrader 5 account through the AI Agent.\n\n" +
        "You must:\n" +
        "• install the AI Agent on the MT5 account\n" +
        "• connect the account with a valid token\n" +
        "• enable algorithmic trading\n" +
        "• allow the FullMetrix WebRequest\n" +
        "• keep MetaTrader 5 open and connected to the internet\n\n" +
        "Once the account is connected, results are synced automatically.",
    },
    {
      q: "How do I create a challenge?",
      a:
        "You must define:\n" +
        "• the account involved\n" +
        "• the starting balance\n" +
        "• the final target to reach\n" +
        "• the challenge duration\n\n" +
        "Example:\n" +
        "An account holds $50,000 and you want to make 30% over the next 7 days.\n\n" +
        "FullMetrix then computes automatically:\n" +
        "• the total profit to reach\n" +
        "• the average daily profit needed\n" +
        "• the remaining amount\n" +
        "• the challenge progress\n" +
        "• the pace required to reach the final target",
    },
    {
      q: "What are daily targets for?",
      a:
        "Daily targets are mainly reference points.\n\n" +
        "They are not designed to force the trader to make a precise profit every day.\n\n" +
        "They help you see that a large target is reached through a series of small results.\n\n" +
        "For example, a trader can perform well on day one but keep pushing for more without any real need.\n\n" +
        "The challenge shows they are already ahead and do not need to force new positions.",
    },
    {
      q: "Does the challenge put pressure on the trader?",
      a:
        "No.\n\n" +
        "The Challenges section was not designed to push you to trade more or take more risk.\n\n" +
        "Its goal is to give you a clear view of your progress.\n\n" +
        "Never open a position solely to catch up on a daily target.\n\n" +
        "A target is a reference point, not an obligation to trade.",
    },
    {
      q: "How is progress computed?",
      a:
        "Using the data sent automatically by the AI Agent, FullMetrix can track:\n" +
        "• the current balance\n" +
        "• the profit already made\n" +
        "• the amount left to reach\n" +
        "• the progress percentage\n" +
        "• the milestones already reached\n" +
        "• the average pace of the challenge\n\n" +
        "You normally never need to enter your results manually.",
    },
    {
      q: "What does being ahead or behind mean?",
      a:
        "You are ahead when your results are above the level normally expected at that point of the challenge.\n\n" +
        "You are behind when your progress is below the computed reference.\n\n" +
        "These indications only help you understand your situation.\n\n" +
        "They never mean you must trade to catch up.",
    },
    {
      q: "What if I make a lot of profit right at the start?",
      a:
        "If you quickly exceed your intermediate milestone, FullMetrix can show you are ahead.\n\n" +
        "That can let you:\n" +
        "• reduce your exposure\n" +
        "• avoid overtrading\n" +
        "• secure your progress\n" +
        "• stick to your plan\n" +
        "• wait for better opportunities\n\n" +
        "Being ahead does not mean you should keep looking for more trades.",
    },
    {
      q: "What if I am behind?",
      a:
        "If you are behind, FullMetrix shows it so you understand your current pace is below the expected reference.\n\n" +
        "It does not mean you should:\n" +
        "• increase your lot size\n" +
        "• take more positions\n" +
        "• drop your risk management\n" +
        "• force opportunities\n\n" +
        "You can instead:\n" +
        "• revise your target\n" +
        "• extend the duration\n" +
        "• analyse your results\n" +
        "• stay patient\n" +
        "• keep following your strategy",
    },
    {
      q: "Can I follow several challenges?",
      a:
        "Depending on the options available in FullMetrix, you can find:\n" +
        "• active challenges\n" +
        "• successful challenges\n" +
        "• late challenges\n" +
        "• average progress\n" +
        "• total profit generated\n" +
        "• the sync history\n\n" +
        "This lets you compare several targets and follow your evolution over time.",
    },
    {
      q: "Does the challenge guarantee reaching the target?",
      a:
        "No.\n\n" +
        "FullMetrix computes a progress plan and provides reference points.\n\n" +
        "It does not guarantee the target will be reached.\n\n" +
        "The outcome depends on:\n" +
        "• your strategy\n" +
        "• market conditions\n" +
        "• your risk management\n" +
        "• your discipline\n" +
        "• the quality of your decisions\n" +
        "• the performance actually achieved",
    },
    {
      q: "What if the results do not sync?",
      a:
        "Check:\n" +
        "• that MetaTrader 5 is open\n" +
        "• that the AI Agent is active\n" +
        "• that the token is valid\n" +
        "• that algorithmic trading is enabled\n" +
        "• that the FullMetrix WebRequest is still allowed\n" +
        "• that the right account is connected\n" +
        "• that the internet connection works\n\n" +
        "Then refresh the Challenges page.",
    },
    {
      q: "How do I contact support?",
      a:
        "For a faster answer, we recommend contacting FullMargin support on WhatsApp.\n\n" +
        "Please send:\n" +
        "• the email address of your FullMargin account\n" +
        "• the MT5 account involved\n" +
        "• the name of the token used\n" +
        "• the challenge target and duration\n" +
        "• a screenshot of the Challenges page\n" +
        "• a precise description of the problem",
    },
  ],
  related: ["agent-ia-mt5", "journal-auto", "strategy-hub"],
};
